import { useSessionStore } from "@/plugins/store";
import { ApiHeaders } from "@esenda/core-ui/interfaces";

export const getCommonHeaderParams = (): ApiHeaders => {
    const { sessionId, language } = useSessionStore();

    return {
        sessionId,
        language,
    };
};
